import { formatDateToDatepickerDateType } from "@website/ticket-ui/common/helper/formatDateToDatePickerDateType";
import { addSearchBoxInteractedTrackingEvent } from "@website/ticket-ui/common/helper/searchBoxInteractedTrackingEvents";
import { ResultPageQueryParameters } from "@website/ticket-ui/common/types/route-query";
import { DatepickerV2SelectedDateType } from "@website/ui-old/datepicker-v2";
import { useCallback, useEffect, useState } from "react";

const formatSearchDate = (parameters: ResultPageQueryParameters) => {
  const calenderLocale =
    parameters.dateType === "jalali" || !parameters.dateType
      ? "persian"
      : parameters.dateType;
  if (Object.keys(parameters).length > 0) {
    if (parameters.returnDate && parameters.departureDate) {
      return [
        formatDateToDatepickerDateType(
          parameters.departureDate,
          calenderLocale
        ),
        formatDateToDatepickerDateType(parameters.returnDate, calenderLocale)
      ];
    }
    if (parameters.departureDate) {
      return [
        formatDateToDatepickerDateType(parameters.departureDate, calenderLocale)
      ];
    }
  }
  return [];
};

export const useDate = (queryParameters: ResultPageQueryParameters) => {
  const initialDateType =
    queryParameters.dateType === "jalali" || !queryParameters.dateType
      ? "persian"
      : queryParameters.dateType;
  const [date, setDate] = useState<DatepickerV2SelectedDateType>([]);
  const [calendarLocale, setCalendarLocale] = useState<string>(
    initialDateType || ""
  );

  const onChangeDate = useCallback(
    (value: DatepickerV2SelectedDateType, calendarLocale: string) => {
      setDate(value);
      setCalendarLocale(calendarLocale);
      addSearchBoxInteractedTrackingEvent({
        departure_date: value[0]?.dateTime
          ? new Date(value[0]?.dateTime)
          : undefined,
        ...(value.length > 1
          ? { return_departure_date: new Date(value[1]?.dateTime) }
          : {})
      });
    },
    []
  );

  useEffect(() => {
    if (Object.keys(queryParameters).length > 0) {
      setDate(formatSearchDate(queryParameters));
    }
  }, [queryParameters?.departureDate]);

  const onEmptyDate = useCallback(() => {
    setDate([]);
  }, []);

  return {
    date,
    calendarLocale,
    onChangeDate,
    onEmptyDate,
    fromTitle: "تاریخ رفت",
    toTitle: "تاریخ برگشت"
  };
};
